module.exports = __webpack_public_path__ + "static/media/Showcase_06.339051e8.jpg";